/*
 * Copyright (c) 2025, Gather
 * https://gather.life
 */

'use client';

import { Grid2 as Grid } from '@mui/material';
import type { ReactNode } from 'react';

import {
  PageContentsSectionMainPanel,
  PageContentsSectionSidePanel,
} from '@marketplace/gather-ui/layouts';

import { VehicleGrid } from '../components';
import { SearchView } from '../components/search/search.view';

import { FiltersContainerSkeleton } from './filters-container.view';

export default function CatalogVehiclesLoadingView(): ReactNode {
  return (
    <>
      <PageContentsSectionSidePanel minWidth={290} size={3}>
        <FiltersContainerSkeleton />
      </PageContentsSectionSidePanel>
      <PageContentsSectionMainPanel>
        <Grid container direction='column' paddingLeft={{ md: 4 }} spacing={{ base: 3, sm: 6 }}>
          <SearchView disabled loading onSubmit={() => {}} />
          <VehicleGrid
            currentPage={1}
            items={null}
            loadingPattern='initial'
            searchHistoryId={null}
            totalItems={null}
            totalPages={null}
          />
        </Grid>
      </PageContentsSectionMainPanel>
    </>
  );
}
